module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185456.e2d05f48.jpg";